// extracted by mini-css-extract-plugin
export default {"seeAllLink":"HkS4H2dLVYEHIVFv8UAp"};